






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Editor from "@tinymce/tinymce-vue";
import FileSelectModal from "@/components/files/modals/FileSelectModal.vue";
import { dragImage } from "./tinyMcePlugins/dragImagePlugin";
import { draggableBox } from "./tinyMcePlugins/draggableBoxPlugin";
import { FontSizeWithInput } from "./tinyMcePlugins/fontSizeWithInputPlugin";
import "./tinyMcePlugins/plugins.css";
import { FILEENDPOINT } from "@/app.config";
import ChannelAddHtmlPostTemplateModal from "@/components/channels/modals/ChannelAddHtmlPostTemplateModal.vue";
import { getAllContentTemplateSizes, getContentTemplate } from "@/services/contentTemplates/contentTemplateService";
import { getAllFonts, getWebFonts } from "@/services/fonts/fontsService";
import { Font, FontStatusEnum } from "@/services/fonts/types";
import { MediaType } from "@/services/files/types";
import i18n from "@/i18n";
import { getUserEditorProfile } from "@/services/editorProfiles/editorProfilesService";
import { Getter } from "vuex-class";
import DirectFileUpload from "@/components/common/files/DirectFileUpload.vue";
import SelectStockImageModal from "@/components/files/modals/SelectStockImageModal.vue";
import { FolderEntites } from "@/services/folders/types";
const namespace: string = "authentication";

@Component({
    components: {
        DirectFileUpload,
        ChannelAddHtmlItemTemplateModal: ChannelAddHtmlPostTemplateModal,
        Editor,
        SelectStockImageModal,
        "file-select-modal": FileSelectModal
    }
})
export default class TinyMceEditor extends Vue {
    @Prop() private value!: string;
    @Prop() private channelStyle!: any;
    @Prop() private channelId!: any;
    @Prop() private propSize!: any;
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
    @Getter("authentication/getUserHasFolderAccess") getUserHasFolderAccess: any;
    @Getter("getAllowStockImages") allowStockImages!: boolean;
    // local state
    localValue = "";
    init = {};
    loaded = false;
    locale = this.$root.$i18n.locale;
    touched = false;
    fontString = "";
    customWebFontsString = "";
    type = MediaType.ImageAndDocument;
    swap = false;
    folders = FolderEntites;

    // watchers
    @Watch("value")
    onValueChanged() {
        this.localValue = this.value;
    }

    async created() {
        var self = this;

        var css = "";
        if (self.channelStyle.css !== null && self.channelStyle.css !== undefined) {
            css = self.channelStyle.css.newsbox;
        }

        // All the default options
        let toolbar = "undo redo | customImagePlugin directFileUploadPlugin stockImagesDownloadPlugin dragImage draggableBox emoticons | alignleft aligncenter alignright | bold italic strikethrough underline bullist | forecolor backcolor removeformat | fontselect FontSizeWithInput | table tableBorderPlugin | code | customTemplateSelect | backgroundSwapPlugin ";
        const profile = await getUserEditorProfile(this.getCurrentUser.id);

        if (profile) {
            const toolbarArrayDefault = ["undo", "redo", "customImagePlugin", "directFileUploadPlugin", "stockImagesDownloadPlugin", "dragImage", "draggableBox", "emoticons", "alignleft", "aligncenter", "alignright", "bold", "italic", "strikethrough", "underline", "bullist", "forecolor", "backcolor", "removeformat", "fontselect", "FontSizeWithInput", "table", "tableBorderPlugin", "code", "customTemplateSelect", "backgroundSwapPlugin"];

            const toolbarArray: any = [];
            for (const [key, value] of Object.entries(profile.settingsJson)) {
                const val = value.selectedItems;
                if (val.length === 0) continue;
                toolbarArray.push(...val);
            }

            // The difference is the items the user has NOT selected.
            const difference = new Set([...toolbarArrayDefault.filter(x => !new Set([...toolbarArray]).has(x))]);

            // Remove the items they have not selected from the normal string, to maintain the order like above.
            difference.forEach(el => {
                toolbar = toolbar.replace(el + " ", "");
            });

            if (!self.getUserHasFolderAccess) {
                toolbar = toolbar.replace("customImagePlugin", "");
            }

            if (!self.allowStockImages) {
                toolbar = toolbar.replace("stockImagesDownloadPlugin", "");
            }
        }

        // image element toolbar restriction calculation
        let imageToolsToolbar = "";

        if (self.getUserHasFolderAccess) {
            imageToolsToolbar += "customImagePlugin ";
        }

        imageToolsToolbar += "directFileUploadPlugin";

        if (self.allowStockImages) {
            imageToolsToolbar += " stockImagesDownloadPlugin";
        }

        this.loadFonts().then(() => {
            this.init = {
                selector: "textarea#full-featured-non-premium",
                plugins: "quickbars backgroundSwapPlugin strikethrough customTemplateSelect customImagePlugin directFileUploadPlugin stockImagesDownloadPlugin FontSizeWithInput dragImage paste searchreplace autolink code table emoticons imagetools draggableBox tableBorderPlugin lists",
                menubar: false,
                toolbar: toolbar,
                quickbars_image_toolbar: false,
                paste_data_images: true,
                block_formats: "Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre;Div=div",
                image_advtab: false,
                imagetools_toolbar: imageToolsToolbar,
                importcss_append: true,
                content_css: "/tinymce/defaultRender.css",
                font_formats: this.fontString,
                relative_urls: false,
                remove_script_host: false,
                convert_urls: false,
                setup: function (editor: any) {
                    (window as any).tinymce.PluginManager.add("dragImage", dragImage);
                    (window as any).tinymce.PluginManager.add("FontSizeWithInput", FontSizeWithInput);
                    (window as any).tinymce.PluginManager.add("draggableBox", draggableBox);

                    editor.on("init", function () {
                        // Add 30 pixels to width and height to provide a bit of padding
                        var editorFrame = document.getElementById("htmleditor_ifr");
                        if (editorFrame != null) editorFrame.style.cssText = "border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; width: " + (parseInt(self.channelStyle.width) + 27) + "px; height: " + (parseInt(self.channelStyle.height) + 27) + "px;";
                    });

                    editor.on("blur", function () {
                        self.onBlur();
                    });

                    editor.on("paste", function (event: any) {
                        if (event.clipboardData.files.length === 0) {
                            return;
                        }

                        event.preventDefault();
                        (self.$refs.directUpload as any).injectFile(event.clipboardData.files[0]);
                    });

                    editor.on("drop", function (event: any) {
                        if (event.dataTransfer.files.length === 0) {
                            return;
                        }

                        event.preventDefault();
                        (self.$refs.directUpload as any).injectFile(event.dataTransfer.files[0]);
                    });

                    (window as any).tinymce.PluginManager.add("customTemplateSelect", function (editor: any) {
                        editor.ui.registry.addButton("customTemplateSelect", {
                            icon: "vsc-template",
                            tooltip: i18n.t("contentTemplates.selectContentTemplate"),
                            onAction: function () {
                                self.showContentTemplatesDialog();
                            }
                        });
                    });
                    (window as any).tinymce.PluginManager.add("customImagePlugin", function (editor: any) {
                        editor.ui.registry.addButton("customImagePlugin", {
                            icon: "vsc-folder",
                            tooltip: i18n.t("file.selectFile"),
                            onAction: function () {
                                var node: HTMLElement = editor.selection.getNode();
                                if (node.tagName !== "IMG") {
                                    self.showFileManagerDialog();
                                    return;
                                }
                                self.replaceImageshowFileManagerDialog();
                            }
                        });
                    });
                    (window as any).tinymce.PluginManager.add("tableBorderPlugin", function (editor: any) {
                        editor.ui.registry.addToggleButton("tableBorderPlugin", {
                            icon: "vsc-toggle-table-borders",
                            tooltip: i18n.t("htmlEditor.tableBorders"),
                            onSetup: function (api: any) {
                                editor.getBody().classList.add("tableBorder");
                                api.setActive(true);
                            },
                            onAction: function (api: any) {
                                editor.getBody().classList.toggle("tableBorder");
                                api.isActive() ? api.setActive(false) : api.setActive(true);
                            }
                        });
                    });
                    (window as any).tinymce.PluginManager.add("backgroundSwapPlugin", function (editor: any) {
                        editor.ui.registry.addToggleButton("backgroundSwapPlugin", {
                            icon: "backgroundSwap",
                            tooltip: i18n.t("htmlEditor.swap"),
                            onSetup: function () {
                                const dummy = document.createElement("div");
                                dummy.style.cssText = css;
                                const color = dummy.style.color;
                                if (color !== null && color !== "") {
                                    if (color === "white") self.swap = true;
                                    else {
                                        // If it's not a string, we calculate the luminance to determine brightness.
                                        // If it is near white, swap the background to gray
                                        const match = color.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);
                                        const colors = match ? {
                                            red: match[1],
                                            green: match[2],
                                            blue: match[3]
                                        } : {};
                                        if (colors === {}) return;
                                        const lum = 0.2126 * Number(colors.red) + 0.7152 * Number(colors.green) + 0.0722 * Number(colors.blue);
                                        if (lum > 220) self.swap = true;
                                    }
                                }
                            },
                            onAction: function () {
                                self.swap = !self.swap;
                            }
                        });
                    });

                    (window as any).tinymce.PluginManager.add("directFileUploadPlugin", function (editor: any) {
                        editor.ui.registry.addButton("directFileUploadPlugin", {
                            icon: "vsc-image",
                            tooltip: i18n.t("file.uploadFile"),
                            onAction: function () {
                                var node: HTMLElement = editor.selection.getNode();
                                if (node.tagName !== "IMG") {
                                    (self.$refs.directUpload as any).openFileUpload();
                                    return;
                                }
                                (self.$refs.directUploadReplacement as any).openFileUpload();
                            }
                        });
                    });

                    (window as any).tinymce.PluginManager.add("stockImagesDownloadPlugin", function (editor: any) {
                        editor.ui.registry.addButton("stockImagesDownloadPlugin", {
                            icon: "vsc-stock-image",
                            tooltip: i18n.t("posts.chooseStockImage"),
                            onAction: function () {
                                const node: HTMLElement = editor.selection.getNode();
                                const eventName = node.tagName.toLowerCase() === "img" ? "replaceImage" : "insertImage";
                                (self.$refs.stockImagesModal as any).open(eventName);
                            }
                        });
                    });

                    editor.ui.registry.addIcon("vsc-image", "<svg style='width: 22px; height: 22px;' class=\"vc-icon\"><use xlink:href=\"#direct-image-upload\"></use></svg>");
                    editor.ui.registry.addIcon("vsc-stock-image", "<svg style='width: 22px; height: 22px;' class=\"vc-icon\"><use xlink:href=\"#stock-image-upload\"></use></svg>");
                    editor.ui.registry.addIcon("vsc-toggle-table-borders", "<svg style='width: 22px; height: 22px;' class=\"vc-icon\"><use xlink:href=\"#toggle-table-grid-icon\"></use></svg>");
                    editor.ui.registry.addIcon("vsc-draggable", '<svg width="21" height="21" viewBox="0 0 12.29 12.284"><g transform="translate(-16.14 -497.634)"><path d="M34.719,501.453a.545.545,0,0,1-.386-.931l.978-.978-.978-.978a.545.545,0,0,1,.771-.771l1.364,1.364a.545.545,0,0,1,0,.771L35.1,501.293A.544.544,0,0,1,34.719,501.453Z" transform="translate(-8.198 0)"/><path d="M18.049,501.453a.544.544,0,0,1-.386-.16L16.3,499.929a.545.545,0,0,1,0-.771l1.364-1.364a.545.545,0,0,1,.771.771l-.978.978.978.978a.545.545,0,0,1-.386.931Z" transform="translate(0 0)"/><path d="M26.914,509.918H22.808a1.18,1.18,0,0,1-.915-.434l-2.775-3.617a1.106,1.106,0,0,1,.165-1.545,1.7,1.7,0,0,1,1.381-.361,2.139,2.139,0,0,1,1,.466l.192.175v-5.291a1.66,1.66,0,0,1,1.434-1.666,1.543,1.543,0,0,1,1.224.377,1.687,1.687,0,0,1,.556,1.266v3.177a5.7,5.7,0,0,1,3.056,1.178,1.915,1.915,0,0,1,.624,1.292,9.722,9.722,0,0,1-.7,3.626l-.239.71A.948.948,0,0,1,26.914,509.918Zm-6.549-4.892a.616.616,0,0,0-.39.14l2.772,3.641a.1.1,0,0,0,.061.02h4l.207-.614a8.857,8.857,0,0,0,.644-3.2.829.829,0,0,0-.27-.558,4.86,4.86,0,0,0-2.5-.909l-.113-.015a.932.932,0,0,1-.8-.92v-3.319a.593.593,0,0,0-.189-.449.446.446,0,0,0-.37-.11.575.575,0,0,0-.475.582v5.562a.972.972,0,0,1-1.6.744l-.406-.369a1.031,1.031,0,0,0-.472-.213A.607.607,0,0,0,20.365,505.026Z" transform="translate(-1.244)"/></g></svg>');
                    editor.ui.registry.addIcon("vsc-template", "<svg style='width: 20px; height: 20px' class=\"vc-icon\"><use xlink:href=\"#item-type-html-icon\"></use></svg>");
                    editor.ui.registry.addIcon("backgroundSwap", `<svg class="swapbackgroundwhite vc-icon vc-icon_xl" viewBox="0 0 100 100"><use xlink:href="#switch-grey-white-icon" /></svg><svg class="swapbackgroundgray vc-icon vc-icon_xl" viewBox="0 0 100 100"><use xlink:href="#switch-white-grey-icon" /></svg>`);
                    editor.ui.registry.addIcon("vsc-folder", "<svg style='width: 22px; height: 22px;' class=\"vc-icon\"><use xlink:href=\"#folder-icon\"></use></svg>");
                    // TODO: Perhaps, if the image is larger than the editor, we resize the image on the server onselect,
                    //       so the user doesn't have 4k images in a 500px wide editor.
                    self.onSelect = function (file: any, closeDialog = false) {
                        // closeDialog is true only when this method is called as a callback from the filemanager component
                        // when using directUpload there's no need to close any dialogs since the directUpload component
                        // uses only the dialog from the file input which closes itself
                        if (file.name.endsWith(".pdf")) {
                            editor.insertContent(`<iframe scrolling="no" type="application/pdf" src="${FILEENDPOINT}${file.fileId}?#toolbar=0&statusbar=0&messages=0&navpanes=0&scrollbar=0&view=fit&frameBorder=0" style="width: ${self.channelStyle.width}px; height: ${self.channelStyle.height}px; display: block; overflow: hidden;"></iframe>`);
                            if (closeDialog) {
                                (self.$refs.fileManagerDialog as any).close();
                            }
                        } else {
                            const img = new Image();
                            img.src = FILEENDPOINT + file.fileId;

                            img.onload = function () {
                                editor
                                    .insertContent(`<img data-mce-style="max-width: 100%; max-height:${self.channelStyle.height}px;" style="max-width: 100%; max-height:${self.channelStyle.height}px;" src='${FILEENDPOINT}${file.fileId}' />`);
                                if (closeDialog) {
                                    (self.$refs.fileManagerDialog as any).close();
                                }
                            };
                        }
                    };

                    self.replaceImageonSelect = function (file: any, closeDialog: boolean) {
                        // closeDialog is true only when this method is called as a callback from the filemanager component
                        // when using directUpload there's no need to close any dialogs since the directUpload component
                        // uses only the dialog from the file input which closes itself
                        if (file.name.endsWith(".pdf")) {
                            editor.insertContent(`<iframe scrolling="no" type="application/pdf" src="${FILEENDPOINT}${file.fileId}?#toolbar=0&statusbar=0&messages=0&navpanes=0&scrollbar=0&view=fit&frameBorder=0" style="width: ${self.channelStyle.width}px; height: ${self.channelStyle.height}px; display: block; overflow: hidden;"></iframe>`);
                            if (closeDialog) {
                                (self.$refs.replaceImage as any).close();
                            }
                            return;
                        }

                        var node: HTMLImageElement = editor.selection.getNode();
                        const img = new Image();
                        img.src = FILEENDPOINT + file.fileId;

                        img.onload = function () {
                            if (node.src !== undefined) {
                                const ratio = Math.min(node.width / img.width, node.height / img.height);

                                node.src = `${FILEENDPOINT}${file.fileId}`;
                                if (img.width >= node.width || img.height >= node.height) {
                                    node.style.width = img.width * ratio + "px";
                                    node.style.height = img.height * ratio + "px";
                                } else {
                                    node.style.width = img.width + "px";
                                    node.style.height = img.height + "px";
                                }
                                node.setAttribute("data-mce-src", `${FILEENDPOINT}${file.fileId}`);
                                node.setAttribute("data-mce-style", node.style.cssText);
                                self.localValue = editor.getContent();
                            }

                            if (closeDialog) {
                                (self.$refs.replaceImage as any).close();
                            }
                            setTimeout(() => {
                                node.click();
                            }, 400);
                        };
                    };
                    self.toggleHeaderButtons = function (state: boolean) {
                        self.$emit("toggleHeaderButtons", state);
                    };

                    editor.on("ObjectResized", function (e: any) {
                        if (e.target.tagName.toLowerCase() === "table") {
                            if (e.target.style.width.replace(/\D/g, "") > parseInt(self.channelStyle.width)) {
                                self.$nextTick(() => {
                                    e.target.style.width = self.channelStyle.width + "px";
                                });
                            }
                            if (e.target.style.height.replace(/\D/g, "") > parseInt(self.channelStyle.height)) {
                                self.$nextTick(() => {
                                    e.target.style.height = self.channelStyle.height + "px";
                                });
                            }
                        }

                        if (e.target.tagName.toLowerCase() === "img") {
                            const node = e.target;
                            const width = Number.isNaN(parseInt(node.style.width)) ? node.getAttribute("width") : node.style.width;
                            const height = Number.isNaN(parseInt(node.style.height)) ? node.getAttribute("height") : node.style.height;
                            const ratio = Math.min(node.width / parseInt(width), node.height / parseInt(height));
                            node.style.width = (parseInt(width) * ratio) + "px";
                            node.style.height = (parseInt(height) * ratio) + "px";
                            node.removeAttribute("width");
                            node.removeAttribute("height");
                            node.setAttribute("data-mce-style", node.style.cssText);
                        }
                    });

                    editor.on("ExecCommand", function (evt: any) {
                        const cmd = evt.command;
                        if (cmd === "FontSize") {
                            const size = evt.value;
                            const node = evt.target.selection.getNode();
                            const nodeParent = node.parentNode;
                            if (node.nodeName === "SPAN" && nodeParent.nodeName === "LI") {
                                editor.dom.setStyle(nodeParent, "font-size", size);
                            } else if (node.nodeName === "UL") {
                                const li = editor.dom.select("li", node);
                                editor.dom.setStyle(li, "font-size", size);
                            }
                        }

                        if (cmd === "InsertUnorderedList") {
                            const size = editor.queryCommandValue("fontSize");
                            const node = evt.target.selection.getNode();
                            const li = node.closest("li") ? node.closest("li") : node.getElementsByTagName("li");
                            editor.dom.setStyle(li, "font-size", size);
                        }
                    });
                },
                quickbars_insert_toolbar: false,
                template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
                template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
                height: (parseInt(self.channelStyle.height) + 127) + "px",
                width: (parseInt(self.channelStyle.width) + 29) <= 1200 ? 1200 + "px" : (parseInt(self.channelStyle.width) + 29) + "px",
                preview_styles: false,
                table_default_styles: {
                    width: "100%"
                },
                table_toolbar: "",
                image_caption: true,
                quickbars_selection_toolbar: "bold | customImagePlugin",
                toolbar_mode: "sliding",
                language: self.locale,
                table_sizing_mode: "fixed",
                contextmenu: "table",
                content_style: `
                    body img { max-width: 100%; }
                    body.tableBorder table td {
                        outline: 1px dashed #ccc;
                    }
                    .textBox { outline: 1px dashed #ccc; }
                    .textBox:after {
                        z-index: 99;
                        content: " ";
                        border-radius: 2px;
                        cursor: move;
                        position: absolute;
                        width: 10px;
                        height: 10px;
                        background: #82AAB4;
                        bottom: -12px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                    ${this.customWebFontsString}
                    .imageDrag {cursor:move}
                    ` + "body { " + css + " }" + "body {margin: 13px; box-sizing: border-box; overflow: hidden; position: absolute;top: 0;left: 0;width:" + (self.channelStyle.width) + "px;" + "height:" + (self.channelStyle.height) + "px;" + "}"
            };
            this.loaded = true;
        });
    }

    mounted() {
        if (this.value.length > 0) {
            this.localValue = this.value;
        }
    }

    // Intentionally empty function. Gets overwritten inside the editor so it has the right scope.
    onSelect = function (file: any, closeDialog: boolean) { };
    replaceImageonSelect = function (file: any, closeDialog: boolean) { };
    toggleHeaderButtons = function (state: boolean) {};
    showFileManagerDialog() {
        (this.$refs.fileManagerDialog as any).open();
    }

    replaceImageshowFileManagerDialog() {
        (this.$refs.replaceImage as any).open();
    }

    async showContentTemplatesDialog() {
        const sizes = await getAllContentTemplateSizes();
        (this.$refs.addHtmlItemTemplateModal as any).open(false, sizes);
    }

    onContentTemplateSelected(contentTemplateId: string) {
        getContentTemplate(contentTemplateId).then(response => {
            this.localValue = response.content.html;
        });
    }

    onBlur() {
        this.$emit("editorBlur", this.model);
    }

    get model() {
        return this.localValue;
    }

    set model(html: any) {
        this.touched = true;
        this.localValue = html;
    }

    get editorHeight() {
        return this.channelStyle.height ? this.channelStyle.height + 200 : 700;
    }

    get editorWidth() {
        return window.innerWidth ? window.innerWidth - (window.innerWidth / 100 * 40) : 500;
    }

    async loadFonts() {
        let localFonts: Font[] = await getAllFonts();
        this.customWebFontsString = await getWebFonts();
        localFonts = localFonts.filter(f => f.status === FontStatusEnum.Active);

        if (localFonts.length > 0) {
            localFonts.sort((a, b) => a.displayName.localeCompare(b.displayName));
            this.fontString = "";
            for (let index = 0; index < localFonts.length; index++) {
                const element = localFonts[index];
                this.fontString += `${element.displayName}=${element.technicalName};`;
            }
        }
    }

    emitData() {
        this.touched = true;
        this.$emit(
            "contentUpdated",
            JSON.stringify({
                html: this.model
            })
        );
    }
}
